import toast from "react-hot-toast";
import {BaseClient} from "../../Api/HttpClient";
import {transformObjectToGetRequestParams} from "../../Utils/HttpHelper";

export const createStatisticsSlice = (set, get) => ({
    shiftStatistics: [],
    monthInvoicedStatistics: [],

    getStatisticsForCustomer: async (customer_id= null, start_date= null , end_date = null, branch_id = null) => {
        await BaseClient().get(`/stats/customers/${customer_id}/shifts?` + transformObjectToGetRequestParams({start_date, end_date, branch_id}))
            .then(response => {
                if (response.status === 200) {
                    set({shiftStatistics: response.data?.shifts})
                    set({monthInvoicedStatistics: response.data?.invoiced})
                } else {
                    toast.error(response.data);
                }
            })
    }
})